import { Box, Button, Grid, InputAdornment, InputBase, MenuItem, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import { ChargeCategory } from "../../Objects/ChargeCategory";

export interface ChargeCategoryFormProps {
    onCancel?: () => void
    onSubmit: (chargeCategory: ChargeCategory) => void
    chargeCategory?: ChargeCategory
}

export function ChargeCategoryForm({
    onCancel,
    onSubmit,
    chargeCategory,
}: ChargeCategoryFormProps): JSX.Element {
    const [inputChargeCategory, setInputChargeCategory] = React.useState<ChargeCategory>({})

    const handleSubmit = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        onSubmit(inputChargeCategory)
    }, [inputChargeCategory, onSubmit])

    React.useEffect(() => {
        if (chargeCategory) {
            setInputChargeCategory(chargeCategory)
        }
    }, [chargeCategory])

    return (
        <Box
            component={"form"}
            sx={{
                padding: 2,
            }}
            onSubmit={handleSubmit}
        >
            <Grid container
                spacing={2}
            >
                <Grid item xs={12} sm={8}>
                    <TextField
                        name="chrcate_name"
                        label="料金カテゴリ名"
                        size="small"
                        fullWidth
                        value={inputChargeCategory.chrcate_name ?? ""}
                        onChange={e => {
                            setInputChargeCategory(prev => {
                                return {
                                    ...prev,
                                    chrcate_name: e.target.value
                                }
                            })
                        }}
                    />
                </Grid>
                <Grid item xs={6} sm={4}>
                    <TextField
                        select
                        name="member"
                        label="会員フラグ"
                        size="small"
                        fullWidth
                        defaultValue={"true"}
                        value={inputChargeCategory.member ? "true" : "false"}
                        onChange={e => {
                            setInputChargeCategory(prev => {
                                return {
                                    ...prev,
                                    member: e.target.value === "true"
                                }
                            })
                        }}
                    >
                        <MenuItem value={"true"}>会員</MenuItem>
                        <MenuItem value={"false"}>非会員</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <Box
                        sx={{
                            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                        }}
                    >
                        <Grid container
                            alignItems={"center"}
                            spacing={3}
                            rowSpacing={0.1}
                        >
                            <Grid item xs={12} sm={4}>
                                <Typography variant="caption">適用人数</Typography>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <InputBase
                                    name="min_number"
                                    endAdornment={<InputAdornment position="end">人以上</InputAdornment>}
                                    value={inputChargeCategory.min_number ?? ""}
                                    onChange={e => {
                                        setInputChargeCategory(prev => {
                                            return {
                                                ...prev,
                                                min_number: isNaN(Number(e.target.value)) ? undefined : parseInt(e.target.value)
                                            }
                                        })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <InputBase
                                    name="max_number"
                                    endAdornment={<InputAdornment position="end">人以下</InputAdornment>}
                                    value={inputChargeCategory.max_number ?? ""}
                                    onChange={e => {
                                        setInputChargeCategory(prev => {
                                            return {
                                                ...prev,
                                                max_number: isNaN(Number(e.target.value)) ? undefined : parseInt(e.target.value)
                                            }
                                        })
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box
                        sx={{
                            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                        }}
                    >
                        <Grid container
                            alignItems={"center"}
                            spacing={3}
                            rowSpacing={0.1}
                        >
                            <Grid item xs={12} sm={4} p={0}>
                                <Typography variant="caption">適用予約タイミング</Typography>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <InputBase
                                    name="rvtiming_start"
                                    endAdornment={<InputAdornment position="end">日前から</InputAdornment>}
                                    value={inputChargeCategory.rvtiming_start ?? ""}
                                    onChange={e => {
                                        setInputChargeCategory(prev => {
                                            return {
                                                ...prev,
                                                rvtiming_start: isNaN(Number(e.target.value)) ? undefined : parseInt(e.target.value)
                                            }
                                        })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <InputBase
                                    name="rvtiming_end"
                                    endAdornment={<InputAdornment position="end">日前まで</InputAdornment>}
                                    value={inputChargeCategory.rvtiming_end ?? ""}
                                    onChange={e => {
                                        setInputChargeCategory(prev => {
                                            return {
                                                ...prev,
                                                rvtiming_end: isNaN(Number(e.target.value)) ? undefined : parseInt(e.target.value)
                                            }
                                        })
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box
                        sx={{
                            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                        }}
                    >
                        <Grid container
                            alignItems={"center"}
                            spacing={3}
                            rowSpacing={0.1}
                        >
                            <Grid item xs={12} sm={4}>
                                <Typography variant="caption">最大コマ数</Typography>
                            </Grid>
                            <Grid item xs={6} sm={4}>
                                <InputBase
                                    name="max_unit"
                                    endAdornment={<InputAdornment position="end">コマまで</InputAdornment>}
                                    value={inputChargeCategory.max_unit ?? ""}
                                    onChange={e => {
                                        setInputChargeCategory(prev => {
                                            return {
                                                ...prev,
                                                max_unit: isNaN(Number(e.target.value)) ? undefined : parseInt(e.target.value)
                                            }
                                        })
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        pt={2}
                    >
                        {onCancel &&
                            <Button
                                variant="outlined"
                                onClick={onCancel}
                            >キャンセル</Button>
                        }
                        <Button
                            type="submit"
                            variant="contained"
                        >{chargeCategory ? "更新" : "新規登録"}</Button>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}